module.exports = __webpack_public_path__ + "static/media/registp02_zhCht.57339953.png";